import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  homepage: {
    width: '100%',
    margin: '30px auto',
    paddingTop: '60px'
  },
  title: {
    marginLeft: '9.5vw',
    fontWeight: '500',
    fontSize: '1.4rem',
    color: '#248'
  },
  subject: {
    height: '30vw',
    width: '100%'
  },
  titleContainer: {
    height: '10%'
  },
  sliderContainer: {
    height: '90%'
  },
  sidebar: {
    width: '200px'
  },
  content: {
    position: 'relative',
    right: '6%'
  }
});
